import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AbstractOrderApiService } from './services/abstract/abstract-order-api-service';
import { AbstractProblemApiService } from './services/abstract/abstract-problem-api-service';
import { AbstractProblemForUserApiService } from './services/abstract/abstract-problem-for-user-api-service';
import { AbstractSelfDiagnosticApiService } from './services/abstract/abstract-self-diagnostic-api-service';
import { AbstractEntityService } from './services/abstract/abstract-entity-service';
import { AbstractUrgencyService } from './services/abstract/abstract-urgency-api-service';
import { AbstractServiceCatalogApiService } from './services/abstract/abstract-service-catalog-api-service';
import { AbstractServiceTypeService } from './services/abstract/abstract-service-type-service';
import { AbstractOrderUIService } from './services/abstract/abstract-order-ui-service';
import { UserApiService } from './services/user-api-service';
import { AuthService } from './services/auth-service';
import { AbstractSelfDiagnosisApiService } from './services/abstract/abstract-self-diagnosis-api-service';
import { AbstractNotificationTemplateApiService } from './services/abstract/abstract-notification-template-api-service';

import { OrderApiService } from './services/concrete/order-api-service';
import { ProblemApiService } from './services/concrete/problem-api-service';
import { ProblemForUserApiService } from './services/concrete/problem-for-user-api-service';
import { SelfDiagnosticApiService } from './services/concrete/self-diagnostic-api-service';
import { EntityService } from './services/concrete/entity-service';
import { UrgencyService } from './services/concrete/urgency-api-service';
import { ServiceCatalogApiService } from './services/concrete/service-catalog-api-service';
import { ServiceTypeService } from './services/concrete/service-type-service';
import { OrderUIService } from './services/concrete/order-ui-service';
import { SelfDiagnosisApiService } from './services/concrete/self-diagnosis-api-service';
import { NotificationTemplateApiService } from './services/concrete/notification-template-api-service';
import { AbstractDashboardApiService } from './services/abstract/abstract-dashboard-api-service';
import { DashboardApiService } from './services/concrete/dashboard-api-service';
import { AbstractTopServiceApiService } from './services/abstract/abstract-top-service-api-service';
import { TopServiceApiService } from './services/concrete/top-service-api-service';
import { AbstractOrdersSearchResaltViewTemplateApiService } from './services/abstract/abstract-orders-search-resalt-view-template-api-service';
import { OrdersSearchResaltViewTemplateApiService } from './services/concrete/orders-search-resalt-view-template-api-service';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    DatePipe,
    { provide: AbstractOrderApiService, useClass: OrderApiService },
    { provide: AbstractProblemApiService, useClass: ProblemApiService },
    { provide: AbstractProblemForUserApiService, useClass: ProblemForUserApiService },
    { provide: AbstractSelfDiagnosticApiService, useClass: SelfDiagnosticApiService },
    { provide: AbstractEntityService, useClass: EntityService },
    { provide: AbstractUrgencyService, useClass: UrgencyService },
    { provide: AbstractServiceCatalogApiService, useClass: ServiceCatalogApiService },
    { provide: AbstractSelfDiagnosisApiService, useClass: SelfDiagnosisApiService },
    { provide: AbstractServiceTypeService, useClass: ServiceTypeService },
    { provide: AbstractOrderUIService, useClass: OrderUIService },

    { provide: AbstractNotificationTemplateApiService, useClass: NotificationTemplateApiService },
    { provide: AbstractDashboardApiService, useClass: DashboardApiService },
    { provide: AbstractTopServiceApiService, useClass: TopServiceApiService },
    {
      provide: AbstractOrdersSearchResaltViewTemplateApiService,
      useClass: OrdersSearchResaltViewTemplateApiService,
    },
    AuthService,
    UserApiService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {}
